import { Confirm } from "notiflix"

export const confirmSapImportSubmit = (entityLabel: string): Promise<boolean> =>
  new Promise((resolve) => {
    Confirm.show(
      `Submit ${entityLabel}`,
      "Please verify the imported data carefully. Incorrect submissions may not be editable in the application.",
      "Submit",
      "Review Again",
      () => resolve(true),
      () => resolve(false),
    )
  })
